import { render, staticRenderFns } from "./ActionSheet.vue?vue&type=template&id=3afea3e4&scoped=true&"
import script from "./ActionSheet.vue?vue&type=script&lang=js&"
export * from "./ActionSheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afea3e4",
  null
  
)

export default component.exports